import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Observable } from "rxjs";
import { AddLearnerOfflineActivityDto, EditLearnerOfflineActivityDto, LearnerLearningRecord } from "../_models/LearnerLearningRecord";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class LearnerOfflineActivityService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "learningtracking/";
  private static readonly ADD_LEARNER_OFFLINE_ACTIVITY = "learner/addofflineactivity";
  private static readonly UPDATE_LEARNER_OFFLINE_ACTIVITY = "learner/updateofflineactivity";
  private static readonly GET_OFFLINE_ACTIVITY_SKILL = "learner/getskillselection";
  private static readonly GET_OFFLINE_ACTIVITY = "learner/getofflineactivity";

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public createLearnerOfflineActivity$(offlineActivity: AddLearnerOfflineActivityDto): Observable<AddLearnerOfflineActivityDto> {
    return this.http.post<AddLearnerOfflineActivityDto>(
      this.baseUrl + 
      LearnerOfflineActivityService.path + 
      LearnerOfflineActivityService.ADD_LEARNER_OFFLINE_ACTIVITY,
      offlineActivity
    );
  }

  public updateLearnerOfflineActivity$(offlineActivity: EditLearnerOfflineActivityDto): Observable<EditLearnerOfflineActivityDto> {
    return this.http.put<EditLearnerOfflineActivityDto>(
      this.baseUrl + 
      LearnerOfflineActivityService.path + 
      LearnerOfflineActivityService.UPDATE_LEARNER_OFFLINE_ACTIVITY,
      offlineActivity
    );
  }

  public getOfflineActivitySkill$(courseId: number): Observable<string[]> {
    return this.http.get<string[]>(
      this.baseUrl +
      LearnerOfflineActivityService.path +
      LearnerOfflineActivityService.GET_OFFLINE_ACTIVITY_SKILL + 
      AppConstants.SLASH + 
      courseId
    );
  }

  public getOfflineActivity$(scormEntryId: number): Observable<LearnerLearningRecord> {
    let params: HttpParams = new HttpParams();
    params = params.append(AppConstants.SCORM_ENTRY_EDIT, String(scormEntryId));
    return this.http.get<LearnerLearningRecord>(
      this.baseUrl +
      LearnerOfflineActivityService.path +
      LearnerOfflineActivityService.GET_OFFLINE_ACTIVITY + 
      AppConstants.SLASH,
      {params}
    );
  }
}